import React from 'react';
import {Grid, Row, Col} from 'react-bootstrap';
import PropTypes from 'prop-types';

function PlateViewInstructionGuide({title, titleDesc, Steps}) {
  const stepElements = [];
  for (let iSteps = 0; iSteps < Steps.length; iSteps += 1) {
    const step = Steps[iSteps];
    stepElements.push(
      <>
        <Row>
          <Col className="section-title grey">{`Step ${iSteps + 1}`}</Col>
        </Row>
        <Row>
          <Col className="section-additional-info">{step}</Col>
        </Row>
      </>,
    );
  }
  return (
    <Grid fluid className="plate-view-tutorial-steps">
      <Row>
        <Col className="section-title bordered">{title}</Col>
      </Row>
      <Row>
        <Col className="section-additional-info grey">{titleDesc}</Col>
      </Row>
      <div className="steps-container">{stepElements}</div>
    </Grid>
  );
}

export default PlateViewInstructionGuide;

PlateViewInstructionGuide.propTypes = {
  title: PropTypes.string.isRequired,
  titleDesc: PropTypes.string.isRequired,
  Steps: PropTypes.array.isRequired,
};
